/**
 * Emit hosts for the `button` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type TrackButtonClickedInput } from '@/models/analyticsScribeModel';

export function trackButtonClicked(input: TrackButtonClickedInput) {
  const { screenName, taskId, clickSource, ...rest } = input;

  track({
    event_name: TrackingEventName.ButtonClicked,
    props: {
      ...rest,
      // Legacy camelCase shortcuts win when both shapes are passed; in
      // practice no caller supplies both. Each only overrides when
      // defined so a caller passing only `screen_name` keeps that
      // value instead of silently being undefined-overwritten.
      ...(screenName !== undefined && { screen_name: screenName }),
      ...(taskId !== undefined && { task_id: taskId }),
      ...(clickSource !== undefined && { click_source: clickSource }),
    },
    options: { amplitude: false },
  });
}
